// File: components/Payments/MobileStatsCard.jsx
import React from 'react';
import { formatCurrency, parseCurrency } from '../../utils/format';

const ABN_PENDING = [
  'Waiting For Invoice', 'Waiting Approval', 'In Progress',
  'ON HOLD', 'Yes Invoice', 'Pending Payment',
  'Creating PO Document', 'Send Purchase Order'
];

const MobileStatsCard = ({ payments, activeChip, helpButton = null }) => {
  const totalFiltered = payments.reduce((sum, p) => {
    const amt = p.type === 'ABN' ? parseCurrency(p[7]) : parseCurrency(p[4]);
    return sum + amt;
  }, 0);

  const pendingCount = payments.filter(p => {
    if (p.type === 'ABN') return ABN_PENDING.includes(p[3]);
    if (p.type === 'TFN') return p[17] === 'Not_Paid';
    return false;
  }).length;

  const label = activeChip === 'All'
    ? 'Total'
    : activeChip === 'Current'
      ? 'Current Period'
      : activeChip;

  return (
    <div className="fp-stats-card">
      <div className="fp-stats-gradient-bar" />
      <div className="fp-stats-inner">
        <div>
          <p className="fp-stats-label">{label} Payments</p>
          <p className="fp-stats-amount">{formatCurrency(totalFiltered)}</p>
        </div>
        <div className="fp-stats-right">
          <p className="fp-stats-label">Pending</p>
          <div className="fp-stats-pending-badge">{pendingCount}</div>
        </div>
      </div>
      
       <div className="fp-stats-count">
        <span>{payments.length} record{payments.length !== 1 ? 's' : ''}</span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {helpButton}
         
      </div>
      </div>
    </div>
  );
};

export default MobileStatsCard;